export const readPickerIds = (value: unknown, key: 'pimProductIds' | 'categoryIds'): string[] => {
  if (value === null || value === undefined) return [];
  if (typeof value !== 'object' || Array.isArray(value) || !(key in value))
    throw new Error(`Invalid product picker selection: ${key}`);
  const ids = (value as Record<string, unknown>)[key];
  if (!Array.isArray(ids) || ids.some((id) => typeof id !== 'string' || !id.trim()))
    throw new Error(`Invalid product picker identifiers: ${key}`);
  return [...new Set(ids as string[])];
};
